import React from 'react';
export const useFileUpload = ({ files })=>{
    const fileInputRef = React.useRef(null);
    const textBelowButtonRef = React.useRef(null);
    const fileHasError = Boolean(files?.find((file)=>file.state === 'error'));
    const isOneFile = files && files.length === 1;
    const fileErrorMessage = fileHasError && isOneFile ? files[0].errorMessage : undefined;
    return {
        fileInputRef,
        textBelowButtonRef,
        fileErrorMessage
    };
};

//# sourceMappingURL=useFileUpload.js.map